import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from 'app/com/ibm/tw/commons/mvc/base.component';
import { TaskViewForm } from 'app/com/ibm/tw/commons/mvc/task.viewform';
import { TxnService } from 'app/services';
import { CommandButtonModule } from 'ui-components/button';
import { EventData, StatusService } from 'ui-components/common';
import { MessagesModule } from 'ui-components/messages';
import { PopupModule } from 'ui-components/popup';
import { ErrorStatus } from '../../../com/ibm/tw/commons/status/error.status';
import { StringUtils } from '../../../com/ibm/tw/commons/utils/string.utils';
import { ShareService } from '../../../services/share.service';
import { AxthenticationService } from './../../../services/axthentication.service';


@Component({
    standalone: true,
    templateUrl: 'error.component.html',
    imports: [
        CommonModule,
        PopupModule,
        CommandButtonModule,
        MessagesModule
    ]
})

export class ErrorComponent extends BaseComponent implements OnInit {

    loading = false;

    error = '';

    errorStatus: ErrorStatus;

    errorDesc: string;

    errorTitle: string;

    backToHomeButtonLabel: string;

    /** GIB-4899 操作時間 */
    systemOperationTime: Date;

    /** GIB-4899 當前區域 */
    currentArea: string;

    @Input() showTitle: boolean = false;

    constructor(
        protected router: Router,
        protected shareService: ShareService,
        protected statusService: StatusService,
        protected axthenticationService: AxthenticationService,
        public txnService: TxnService
    ) {
        super(txnService);
    }

    ngOnInit() {
        // console.log('ErrorComponent init...');
        this.errorTitle = this.txnService.transform('錯誤原因：', 'common00005776', null);
        this.backToHomeButtonLabel = this.txnService.transform('返回首頁', 'common00002648', null);
        this.statusService.hide();
        let errorStatus: ErrorStatus = this.shareService.getAppParamWithClean<ErrorStatus>('error');

        if (!StringUtils.isEmptyObj(errorStatus)) {
            // GIB-4990 操作時間
            if (!StringUtils.isEmptyObj(errorStatus.systemOperationTime)) {
                this.systemOperationTime = errorStatus.systemOperationTime;
            } else {
                this.systemOperationTime = new Date();
            }

            // GIB-4990 當前區域
            if (!StringUtils.isEmptyStr(errorStatus.currentArea)) {
                this.currentArea = errorStatus.currentArea;
            }

            // console.log('錯誤原因 : ' + errorStatus.errorDesc);
            if (StringUtils.isEmptyStr(errorStatus.errorDesc)) {
                this.errorDesc = this.txnService.transform('未知的錯誤原因', 'common00001057', null);
            } else {
                this.errorDesc = errorStatus.errorDesc;
            }

            if (StringUtils.isBlank(errorStatus.errorCode)) {
                this.errorDesc = this.errorDesc;
            } else {
                this.errorDesc = this.errorDesc + ' [' + errorStatus.systemIxd + '-' + errorStatus.errorCode + ']';
            }

        } else {
            // GIB-4990 操作時間
            this.systemOperationTime = new Date();
            // console.log('未知的錯誤原因');
            this.errorDesc = this.txnService.transform('未知的錯誤原因', 'common00001057', null);
        }

        let webErrorMsgs = this.shareService.webErrorMsgs;
        if (webErrorMsgs.length > 30) {
            webErrorMsgs.splice(20, webErrorMsgs.length - 20);
        }
        webErrorMsgs.push(this.errorDesc);
        // GIB-3801 前端的 Error 已在 global.error.handle.ts 處理 doErrorLog, 這邊不用重覆做 doErrorLog
        // GIB-4232 針對編路錯誤及非 SERVER回的錯誤須 處理 doErrorLog
        console.error('errorStatus?.systemIxd', errorStatus);


        if (this.txnService.networkError == true || this.axthenticationService.networkError == true || errorStatus?.systemIxd === undefined) {
            this.txnService.doErrorLog('');
        }
        // GIB-5084 財富處線上KYC 增加交易錯誤訊息超連結
        this.errorStatus = errorStatus;
        this.initViewForm();
    }

    /**
     * GIB-5084 子類覆寫此方法
     */
    protected initViewForm(): void {
    }

    /**
     * 返回首頁
     * @param {EventData} event 事件物件
     */
    doBackHome(event: EventData): void {
        // console.log('welcome...' + this.axthenticationService.welcomePage);
        if (this.axthenticationService.welcomePage) {

            let welcomePage = this.axthenticationService.welcomePage;

            let taskViewForm = new TaskViewForm();

            // taskViewForm.navigatePage = welcomePage.substring(welcomePage.lastIndexOf('.') + 1);
            // GIB_UAT_Issue #63333 改回歡迎頁面
            taskViewForm.navigatePage = 'ccmhmwelc'; // taskViewForm.navigatePage.substring(0, taskViewForm.navigatePage.indexOf('home'));

            taskViewForm.basePath = 'pagecode.chm.ccmhmwelc'; // welcomePage.substring(0, welcomePage.lastIndexOf('.'));

            this.axthenticationService.doInitPage(taskViewForm, this.statusService);

        } else {
            //  this.router.navigateByUrl(`/`);

            let url: string = window.location.href;
            if (url.indexOf('/b2c') > -1) {
                window.location.href = '/b2c';
            } else {
                window.location.href = '/';
            }
        }

    }

    /** 
     * GIB-5077 檢查是否為日期型態
     * @param {any} value
     */
    public isValidDate(value: any) {
        return value instanceof Date;
    }

}
